export default __webpack_public_path__ + "static/2271-1f872070542e0cec4dd64b26a55abbdc.gif";